import { axios } from "../../helper/axios";
import { VendorDetailConstant } from "./VendorDetailConstant";

const VendorDetailApi = {};

VendorDetailApi.getVendorDetail = (params) => {
    return axios.get(
      VendorDetailConstant.VENDOR_DETAIL_API,{params}
    );

    };

VendorDetailApi.chargingEnableDisable = ({ id, status }) => {
  return axios.post(VendorDetailConstant.CHARGING_ENABLE_DISABLE_API, {
    connector_id: id,
    status: status,
  });
};

VendorDetailApi.chargingPointEnableDisable = ({ id, status }) => {
  return axios.post(VendorDetailConstant.CHARGING_POINT_ENABLE_DISABLE_API, {
    charge_point_id: id,
    status: status,
  });
};

VendorDetailApi.chargingPointDelete = ({ id }) => {
  return axios.delete(
    VendorDetailConstant.CHARGING_POINT_DELETE_API.replace(":id", id)
  );
};



VendorDetailApi.getRequestViewDetailsVendorApi = ({id}) => {

  return axios.get(`${VendorDetailConstant.GET_REQUEST_VIEW_VENDOR_DETAILS_API}${id.id}`);
  
}

export { VendorDetailApi };
